import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  FibData,
  NewQuestion,
  DuplicateBlankNameError,
  Explanation,
  QuestionSubType,
  TestCaseResultMap,
  SubjectiveExplanation,
  UploadConfigPayload
} from "../types/question-type";
import { initialConfigData } from "../uploadConfig";
// import { ContentViewer } from "./courseStateSliceData.ts";

type NewQuestionState = {
  newQuestion: NewQuestion;
  duplicateBlankNameError: DuplicateBlankNameError;
  isMultimediaUploaded: boolean;
  multimediaLimitMessage: string;
  multimediaLoadingMessage: string;
  multimediaBrokenMessage: string;
};

// const INIT_STATE: Record<string, NewQuestionState> = {};

const NewQuestionStateSlice = createSlice({
  name: "NewQuestionStateSlice",
  initialState: {
    newQuestion: {} as NewQuestion,
    duplicateBlankNameError: { error: false, message: "" },
    testCases: [],
    hiddenTestCases: [],
    visibleTestCases: [],
    testCaseRes: {} as TestCaseResultMap,
    uploadConfigData: initialConfigData as any,
    isMultimediaUploaded: false,
    multimediaLimitMessage: "",
    multimediaLoadingMessage: "",
    multimediaBrokenMessage: ""
  },
  reducers: {
    setNewQuestion(state, action: PayloadAction<NewQuestion>) {
      state.newQuestion = { ...state.newQuestion, ...action.payload };
    },
    createOption(state, action: PayloadAction<FibData>) {
      if (Object.keys(action.payload).length === 0) {
        return state;
      }

      return {
        ...state,
        newQuestion: {
          ...state.newQuestion,
          fibData: { ...state.newQuestion.fibData, ...action.payload }
        }
      };
    },
    updateExplanations(
      state,
      action: PayloadAction<Explanation | SubjectiveExplanation>
    ) {
      return {
        ...state,
        newQuestion: {
          ...state.newQuestion,
          explanation: action.payload
        }
      };
    },
    setSubType(state, action: PayloadAction<QuestionSubType>) {
      return {
        ...state,
        newQuestion: {
          ...state.newQuestion,
          subType: action.payload
        }
      };
    },
    updateFibOptions(state: NewQuestionState, action: PayloadAction<FibData>) {
      return {
        ...state,
        newQuestion: {
          ...state.newQuestion,
          fibData: action.payload
        },
        uploadConfigData: {},
        testCases: [],
        visibleTestCases: [],
        hiddenTestCases: [],
        testCaseRes: {}
      };
    },
    setDuplicateBlankNameError(
      state,
      action: PayloadAction<DuplicateBlankNameError>
    ) {
      return {
        ...state,
        duplicateBlankNameError: action.payload
      };
    },
    updateFibAnswer(state: NewQuestionState, action: PayloadAction<FibData>) {
      const keyToUpdate: string = Object.keys(action.payload)[0];
      const newValue: string = Object.values(action.payload)[0] as string;
      return {
        ...state,
        newQuestion: {
          ...state.newQuestion,
          fibData: {
            ...state.newQuestion.fibData,
            [keyToUpdate]: newValue
          }
        },
        uploadConfigData: {},
        testCases: [],
        visibleTestCases: [],
        hiddenTestCases: [],
        testCaseRes: {}
      };
    },
    setHiddenTestCases(state, action) {
      state.hiddenTestCases = action.payload;
    },
    setVisibleTestCases(state, action) {
      state.visibleTestCases = action.payload;
    },
    setCodingQnTestCases(state, action) {
      state.testCases = action.payload;
    },
    setTestCaseResults(state, actions) {
      state.testCaseRes = actions.payload;
    },
    updateSubjectiveSolution(state, action) {
      return {
        ...state,
        newQuestion: {
          ...state.newQuestion,
          solution: action.payload
        }
      };
    },
    setUploadConfigData(state, action) {
      state.uploadConfigData = action.payload;
    },
    setIsMultimediaUploaded(state, action) {
      state.isMultimediaUploaded = action.payload;
    },
    setMultimediaLimitMessage(state, action) {
      state.multimediaLimitMessage = action.payload;
    },
    setMultimediaBrokenMessage(state, action) {
      state.multimediaBrokenMessage = action.payload;
    },
    setMultimediaLoadingMessage(state, action) {
      state.multimediaLoadingMessage = action.payload;
    }
  }
});

export default NewQuestionStateSlice;

export const NewQuestionStateSliceActions = NewQuestionStateSlice.actions;
